import type {
    AnswerState,
    CardState,
    DynamicCoreQuestionState,
    ForkedAnswerState,
    ForkedQuestionState,
    LinearAnswerState,
    LinearQuestionState,
    PollResultCardState,
    QuestionState,
    ThankYouCardState,
    TitleCardState,
} from './state-types';

export const isDynamicCoreQuestionItem = (
    card: CardState
): card is DynamicCoreQuestionState => card.type === 'dynamicCoreQuestion';

export const isForkedQuestionItem = (
    card: CardState
): card is ForkedQuestionState => card.type === 'forkedQuestion';

export const isLinearQuestionItem = (
    card: CardState
): card is LinearQuestionState => card.type === 'linearQuestion';

export const isQuestionItem = (card: CardState): card is QuestionState =>
    ['forkedQuestion', 'linearQuestion'].includes(card.type);

export const isTitleCardItem = (card: CardState): card is TitleCardState =>
    card.type === 'titleCard';

export const isThankYouCardItem = (
    card: CardState
): card is ThankYouCardState => card.type === 'thankYouCard';

export const isPollResultCardItem = (
    card: CardState
): card is PollResultCardState => card.type === 'pollResultCard';

export const isQuestionCardType = (cardType: CardState['type']) =>
    ['coreQuestion', 'forkedQuestion', 'linearQuestion'].includes(cardType);

export const isForkedAnswerItem = (
    answer: AnswerState
): answer is ForkedAnswerState => answer.type === 'forkedAnswer';

export const isLinearAnswerItem = (
    answer: AnswerState
): answer is LinearAnswerState => answer.type === 'linearAnswer';
